module.exports = __webpack_public_path__ + "static/media/cyber.29393413.svg";